module.exports = __webpack_public_path__ + "static/media/pepperfry.99303f6a.png";